// extracted by mini-css-extract-plugin
module.exports = {"monthLabel":"CustomHeaderWrapper_monthLabel__c1hNt","headerSection":"CustomHeaderWrapper_headerSection__1-Voj","headerLabel":"CustomHeaderWrapper_headerLabel__c5gld"};